// Get video object used for video picker
// Thus, we set `src` to `item.ThumbnailUrl `because we wanna reuse `image-picker`
// which uses `src` as image source.
export const getVideoObjectForImagePickerFromMTObject = (item) => {
  let videoSrc = null;
  if (item.DownloadUrl) {
    const downloadUrlMapping = JSON.parse(item.DownloadUrl);
    const resolutions = Object.keys(downloadUrlMapping).map(h => parseInt(h, 10));
    const smallestResolution = Math.min(...resolutions);
    videoSrc = downloadUrlMapping[smallestResolution];
  }
  const video = {
    id: parseInt(item.Id, 10),
    idString: item.Id,
    src: item.ThumbnailUrl,
    videoSrc,
    thumbnailUrl: item.ThumbnailUrl,
    width: item.Width || 150,
    height: item.Height || 0,
    altText: item.Description || '',
    status: item.Status,
    duration: item.DurationInMilliSeconds || item.DurationInMS,
    durationInMs: item.DurationInMS,
    uploadedTime: item.UploadedTime,
    textFields: [item.Description || ''],
    quality: item.Quality,
    sourceVideoBitRate: item.SourceVideoBitRate,
    metadata: item.Metadata,
  };
  return video;
};

export const getVideoObjectFromInvestAssets = (item) => {
  const DEFAULT_HEIGHT = 954;
  const DEFAULT_WIDTH = 1144;
  const video = {
    id: parseInt(item.XandrAssetId, 10),
    idString: item.XandrAssetId,
    videoSrc: item.Url,
    textFields: [item.Description || ''],
    altText: item.Description || '',
    height: DEFAULT_HEIGHT,
    width: DEFAULT_WIDTH,
  };
  return video;
};
